// Every sessionStorage key the investment profile gate owns starts with this prefix, so
// sign-out can drop the whole family without importing each module that defines one.
const INVESTMENT_PROFILE_KEY_PREFIX = 'investment_profile'

// The draft key carries the user id: sign-out is not guaranteed to run (session expiry,
// tab reuse, a failed sign-out call), and an unscoped draft would hand user A's answers to
// user B in the same tab — one click would then save A's profile onto B's row.
export const investmentProfileDraftKey = (userId: string) => `investment_profile_draft:${userId}`

export const clearInvestmentProfileStorage = () => {
  try {
    Object.keys(window.sessionStorage)
      .filter((key) => key.startsWith(INVESTMENT_PROFILE_KEY_PREFIX))
      .forEach((key) => window.sessionStorage.removeItem(key))
  } catch {
    // Storage can be blocked; nothing to clean up.
  }
}
